import Swiper from "swiper/bundle";

document.addEventListener("page:load", () => {
  function isInViewport(el) {
    const offset = 200; // Minimum visible height
    const rect = el.getBoundingClientRect();

    const afterElementStart =
      rect.y + offset <=
      (window.innerHeight || document.documentElement.clientHeight);
    const afterElementEnd =
      rect.y < 0 && Math.abs(rect.y) > rect.height - offset;

    return afterElementStart && !afterElementEnd;
  }

  const swiperResize = (swiper) => {
    const event = new Event("swiper:resize");
    document.dispatchEvent(event);
  };

  document.querySelectorAll(".swiper-container").forEach((el) => {
    new Swiper(el, {
      centeredSlides: true,
      loop: true,
      speed: 500,
      slidesPerView: 3,
      spaceBetween: 60,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
      },
      on: {
        resize: function (swiper) {
          swiperResize(swiper);
        },
      },
    });
  });

  document
    .querySelectorAll(".js-swiper[data-mode=tesimonials]")
    .forEach((el) => {
      const container = el.querySelector(".js-swiper-container");

      const pages = [...el.querySelectorAll(".js-swiper-page")];

      const setupActivePage = (swiper) => {
        for (const page of pages) {
          page.classList.remove("--active");
        }

        pages[swiper.realIndex]?.classList?.add("--active");
      };

      const swiper = new Swiper(container, {
        centeredSlides: false,
        loop: true,
        speed: 500,
        slidesPerView: 1,
        effect: "fade",
        spaceBetween: 0,
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: el.querySelector(".js-swiper-next"),
          prevEl: el.querySelector(".js-swiper-back"),
        },
        autoplay: {
          delay: 13000,
          running: false,
          disableOnInteraction: true,
        },
        on: {
          resize: function (swiper) {
            swiperResize(swiper);
          },

          init: function (swiper) {
            setupActivePage(swiper);
          },
        },
      });

      swiper.on("activeIndexChange", () => {
        setupActivePage(swiper);
      });

      const mobilePrev = el.querySelector(".js-swiper-back-mobile");
      const mobileNext = el.querySelector(".js-swiper-next-mobile");

      mobilePrev.addEventListener("click", () => {
        swiper.slidePrev();
      });

      mobileNext.addEventListener("click", () => {
        swiper.slideNext();
      });

      //   pages.forEach((page, i) => {
      //     page.addEventListener("click", () => {
      //       swiper.slideTo(i);
      //     });
      //   });
    });

  document
    .querySelectorAll(".js-swiper[data-mode=enterprises]")
    .forEach((el) => {
      const container = el.querySelector(".js-swiper-container");

      const pageTemplate = el.querySelector(".js-swiper-page-template");
      const swiperNav = el.querySelector(".js-swiper-nav");
      const swiperPages = el.querySelector(".js-swiper-pages");

      const setupActivePage = (swiper) => {
        const pages = [...el.querySelectorAll(".js-swiper-page")];

        for (const page of pages) {
          page.classList.remove("--active");
        }

        pages[swiper.activeIndex]?.classList?.add("--active");
      };

      const setupPaging = (swiper) => {
        const slideCount = +el.dataset.slideCount;
        const slidePerView = swiper.params.slidesPerView;

        swiperPages.innerHTML = "";
        swiperNav.style.opacity = 0;
        swiperPages.style.opacity = 0;

        if (slideCount <= slidePerView) {
          return;
        }

        const totalPages = slideCount - slidePerView + 1;

        if (totalPages > 4) {
          swiperNav.style.opacity = 1;
          return;
        }

        let out = [];

        for (let i = 0; i < totalPages; i++) {
          out.push(pageTemplate.innerHTML);
        }

        swiperPages.innerHTML = out.join("");
        swiperPages.style.opacity = 1;
        swiperNav.style.opacity = 1;

        setupActivePage(swiper);
      };

      const swiper = new Swiper(container, {
        centeredSlides: false,
        loop: false,
        speed: 500,
        slidesPerView: 1.5,
        navigation: {
          nextEl: el.querySelector(".js-swiper-next"),
          prevEl: el.querySelector(".js-swiper-back"),
        },

        breakpoints: {
          640: {
            slidesPerView: 2,
            centeredSlides: false,
          },
          768: {
            slidesPerView: 3,
            centeredSlides: false,
          },
          1024: {
            slidesPerView: 4,
            centeredSlides: false,
          },
        },
        on: {
          resize: function (swiper) {
            swiperResize(swiper);
            setupPaging(swiper);
          },
          init: function (swiper) {
            setupPaging(swiper);
          },
        },
      });

      swiper.on("activeIndexChange", () => {
        setupActivePage(swiper);
      });
    });

  document.querySelectorAll(".js-swiper[data-mode=products]").forEach((el) => {
    const container = el.querySelector(".js-swiper-container");

    const pageTemplate = el.querySelector(".js-swiper-page-template");
    const swiperNav = el.querySelector(".js-swiper-nav");
    const swiperPages = el.querySelector(".js-swiper-pages");

    const setupActivePage = (swiper) => {
      const pages = [...el.querySelectorAll(".js-swiper-page")];

      for (const page of pages) {
        page.classList.remove("--active");
      }

      pages[swiper.activeIndex]?.classList?.add("--active");
    };

    const setupPaging = (swiper) => {
      const slideCount = +el.dataset.slideCount;
      const slidePerView = swiper.params.slidesPerView;

      swiperPages.innerHTML = "";
      swiperNav.style.opacity = 0;
      swiperPages.style.opacity = 0;

      if (slideCount <= slidePerView) {
        return;
      }

      const totalPages = slideCount - slidePerView + 1;

      if (totalPages > 4) {
        swiperNav.style.opacity = 1;
        return;
      }

      let out = [];

      for (let i = 0; i < totalPages; i++) {
        out.push(pageTemplate.innerHTML);
      }

      swiperPages.innerHTML = out.join("");
      swiperPages.style.opacity = 1;
      swiperNav.style.opacity = 1;

      setupActivePage(swiper);
    };

    const swiper = new Swiper(container, {
      centeredSlides: false,
      loop: false,
      speed: 500,
      slidesPerView: 1.5,
      navigation: {
        nextEl: el.querySelector(".js-swiper-next"),
        prevEl: el.querySelector(".js-swiper-back"),
      },

      breakpoints: {
        640: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          centeredSlides: false,
        },
      },
      on: {
        resize: function (swiper) {
          swiperResize(swiper);
          setupPaging(swiper);
        },
        init: function (swiper) {
          setupPaging(swiper);
        },
      },
    });

    swiper.on("activeIndexChange", () => {
      setupActivePage(swiper);
    });
  });

  document.querySelectorAll(".js-swiper[data-mode=hero]").forEach((el) => {
    const container = el.querySelector(".js-swiper-container");

    const pageTemplate = el.querySelector(".js-swiper-page-template");
    const swiperNav = el.querySelector(".js-swiper-nav");
    const swiperPages = el.querySelector(".js-swiper-pages");

    const setupActivePage = (swiper) => {
      const pages = [...el.querySelectorAll(".js-swiper-page")];

      for (const page of pages) {
        page.classList.remove("--active");
      }

      pages[swiper.activeIndex]?.classList?.add("--active");
    };

    const setupPaging = (swiper) => {
      const slideCount = +el.dataset.slideCount;
      const slidePerView = swiper.params.slidesPerView;

      swiperPages.innerHTML = "";
      swiperNav.style.opacity = 0;
      swiperPages.style.opacity = 0;

      if (slideCount <= slidePerView) {
        return;
      }

      const totalPages = slideCount - slidePerView + 1;

      if (totalPages > 4) {
        swiperNav.style.opacity = 1;
        return;
      }

      let out = [];

      for (let i = 0; i < totalPages; i++) {
        out.push(pageTemplate.innerHTML);
      }

      swiperPages.innerHTML = out.join("");
      swiperPages.style.opacity = 1;
      swiperNav.style.opacity = 1;

      setupActivePage(swiper);
    };

    const swiper = new Swiper(container, {
      centeredSlides: false,
      loop: false,
      speed: 500,
      slidesPerView: 1,
      effect: "fade",
      spaceBetween: 0,
      fadeEffect: {
        crossFade: true,
      },

      navigation: {
        nextEl: el.querySelector(".js-swiper-next"),
        prevEl: el.querySelector(".js-swiper-back"),
      },
      on: {
        resize: function (swiper) {
          swiperResize(swiper);
          setupPaging(swiper);
        },
        init: function (swiper) {
          setupPaging(swiper);
        },
      },
    });

    swiper.on("activeIndexChange", () => {
      setupActivePage(swiper);
    });
  });

  document.querySelectorAll(".swiper-process").forEach(
    (el) => {
      const swiper = new Swiper(el, {
        centeredSlides: false,
        loop: true,
        speed: 500,
        effect: "fade",
        slidesPerView: 1,
        spaceBetween: 0,
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 13000,
          running: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: el.querySelector(".swiper-pagination"),
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        on: {
          resize: function (swiper) {
            swiperResize(swiper);
          },
        },
      });

      document.addEventListener("scroll", function () {
        if (isInViewport(el)) {
          swiper.autoplay.start();
          el.classList.add("playing");
        } else {
          el.classList.remove("playing");
          swiper.autoplay.stop();
        }
      });
    },
    { passive: true }
  );

  document.querySelectorAll(".swiper-why").forEach((el) => {
    new Swiper(el, {
      centeredSlides: true,
      loop: true,
      speed: 500,
      slidesPerView: 3,
      spaceBetween: 0,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        577: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        992: {
          slidesPerView: 1.5,
          centeredSlides: false,
        },
        1025: {
          slidesPerView: 3,
          centeredSlides: true,
        },
        1440: {
          slidesPerView: 3,
          centeredSlides: true,
        },
      },
      on: {
        resize: function (swiper) {
          swiperResize(swiper);
        },
      },
    });
  });

  document.querySelectorAll(".swiper-container-business").forEach((el) => {
    let slidesPerView = parseInt(el.dataset.slideCount) || 4;

    new Swiper(el, {
      centeredSlides: false,
      loop: el.dataset.loop === "true",
      centerInsufficientSlides:
        el.dataset.loop !== "true" && el.dataset.mode === "listing",
      speed: 500,
      spaceBetween: el.dataset.mode === "listing" ? 0 : 45,
      slidesPerView: slidesPerView,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        577: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        992: {
          slidesPerView: slidesPerView,
          centeredSlides: false,
        },
      },
      on: {
        resize: function (swiper) {
          swiperResize(swiper);
        },
      },
    });
  });

  document.querySelectorAll(".swiper-retailers-carousel").forEach((el) => {
    new Swiper(el, {
      centeredSlides: false,
      loop: el.dataset.loop === "true",
      speed: 500,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 45,
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          centeredSlides: false,
          slidesPerGroup: 1,
        },
        577: {
          slidesPerView: 2,
          centeredSlides: false,
          slidesPerGroup: 2,
        },
        992: {
          slidesPerView: 3,
          centeredSlides: false,
          slidesPerGroup: 3,
        },
      },
    });
  });

  document.querySelectorAll(".swiper-partners-carousel").forEach((el) => {
    new Swiper(el, {
      centeredSlides: false,
      loop: el.dataset.loop === "true",
      speed: 500,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 45,
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          centeredSlides: false,
          slidesPerGroup: 1,
        },
        577: {
          slidesPerView: 2,
          centeredSlides: false,
          slidesPerGroup: 2,
        },
        992: {
          slidesPerView: 3,
          centeredSlides: false,
          slidesPerGroup: 3,
        },
      },
    });
  });
});
